import { getFeedback } from '@sentry/react';

type FeedbackIntegration = NonNullable<ReturnType<typeof getFeedback>>;

type FeedbackDialog = Awaited<ReturnType<FeedbackIntegration['createForm']>>;

let feedbackDialog: FeedbackDialog | undefined;

function clearFeedbackDialog(): void {
  feedbackDialog?.removeFromDom();
  feedbackDialog = undefined;
}

async function getOrCreateFeedbackDialog(feedback: FeedbackIntegration): Promise<FeedbackDialog> {
  if (feedbackDialog) {
    return feedbackDialog;
  }

  feedbackDialog = await feedback.createForm({
    onFormClose: clearFeedbackDialog,
    onFormSubmitted: clearFeedbackDialog,
  });

  return feedbackDialog;
}

export async function openFeedbackDialog(): Promise<boolean> {
  const feedback = getFeedback();
  if (!feedback) {
    console.warn('[sentry-feedback] Feedback integration is unavailable. Check VITE_SENTRY_ENABLED and DSN.');
    return false;
  }

  try {
    const dialog = await getOrCreateFeedbackDialog(feedback);
    dialog.appendToDom();
    dialog.open();
  } catch (error) {
    console.error('[sentry-feedback] Failed to open feedback dialog', error);
    return false;
  }

  return true;
}

export function isFeedbackAvailable(): boolean {
  return Boolean(getFeedback());
}
